export default {
  title: 'Evénements',
  actions: {
    create: 'créer un événement'
  },
  'sentence-action': 'phrase d\'action'
}



// WEBPACK FOOTER //
// ./src/translations/fr/events.js